module.exports = __webpack_public_path__ + "img/spiel2.5b8bda62.jpg";